import "./App.css";
import Section1 from "./components/pages/Section1";
import Section2 from "./components/pages/Section2";
import Section3 from "./components/pages/Section3";
import Section4 from "./components/pages/Section4";

import "./index.css";

function App() {
  return (
    <>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
    </>
  );
}

export default App;
